/* ============
 * Modules Module Mutations
 * ============
 */

import {
  FETCH_ALL_MODULES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_MODULES](state, modules) {
    state.all = modules;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/modules/mutations.js